import { Tag } from "components/DesignSystem/Tag/Tag";
import ToolTip from "components/design/toolTip";
import { House } from "components/icons/Navbar/House";
import { DISPLAY_DATE } from "constants/date";
import dayjs from "dayjs";

type StateColumnProps = {
  stateDetail: string;
  isHomeState: boolean;
  withdrawalDate: string | null;
};

export const StateColumn = ({
  stateDetail,
  isHomeState,
  withdrawalDate,
}: StateColumnProps) => {
  const subtitle = isHomeState
    ? "Incorporated in this state"
    : "Foreign corporation";

  return (
    <div className="t-flex t-flex-col t-gap-1">
      <div className="t-flex t-items-center t-gap-1.5">
        <span className="t-text-body-sm t-font-medium t-text-text-100">
          {stateDetail}
        </span>
        {isHomeState && (
          <ToolTip text="State of Incorporation">
            <span className="t-text-purple t-flex t-items-center">
              <House size="14" />
            </span>
          </ToolTip>
        )}
        {withdrawalDate && (
          <Tag tagType="red" rounded size="small" transparent>
            {`Withdrawn ${dayjs(withdrawalDate).format(DISPLAY_DATE)}`}
          </Tag>
        )}
      </div>
      <div className="t-text-body-sm t-text-text-30">{subtitle}</div>
    </div>
  );
};
